import React from 'react';

export default class ChannelBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            link: props.link,
            customClass: props.customClass
        }
    }

    render() {
        return (
            <>
                <a className={"Channel " + this.state.customClass} href={this.state.link} target="_blank" rel="nofollow noreferrer" />
            </>
        )
    }
}